import { flexRender, Row, Cell } from '@tanstack/react-table';
import { ChevronDownIcon, ChevronRightIcon } from '@heroicons/react/24/solid';

export const TableCell = <T,>({
  cell,
  row,
  enableRowClickable,
}: {
  cell: Cell<T, unknown>;
  row: Row<T>;
  enableRowClickable?: boolean;
}) => {
  return (
    <td
      key={cell.id}
      className={`${
        cell.getIsGrouped() || cell.column.id === 'select' ? '' : 'px-4'
      } py-4 text-sm text-gray-700 dark:text-gray-300`}
    >
      {cell.getIsGrouped() ? (
        // If it's a grouped cell, add an expander and row count
        <>
          <button
            className="flex w-full items-center gap-2 text-left text-sm"
            {...{
              onClick: !enableRowClickable
                ? row.getToggleExpandedHandler()
                : () => {},
              style: {
                cursor: row.getCanExpand() ? 'pointer' : 'normal',
              },
            }}
          >
            {row.getIsExpanded() ? (
              <ChevronDownIcon className="h-6 w-6 flex-shrink-0 text-gray-500 dark:text-gray-400" />
            ) : (
              <ChevronRightIcon className="h-6 w-6 flex-shrink-0 text-gray-500 dark:text-gray-400" />
            )}{' '}
            {flexRender(cell.column.columnDef.cell, cell.getContext())}
          </button>
        </>
      ) : cell.getIsAggregated() && row.getIsGrouped() ? (
        // If the cell is aggregated, use the Aggregated
        // renderer for cell
        <>
          {flexRender(
            cell.column.columnDef.aggregatedCell ?? cell.column.columnDef.cell,
            cell.getContext(),
          )}
        </>
      ) : cell.getIsPlaceholder() ? null : ( // For cells with repeated values, render null
        // Otherwise, just render the regular cell
        flexRender(cell.column.columnDef.cell, cell.getContext())
      )}
    </td>
  );
};
